// Site-wide content for Dutton Locks Leisure Ltd
// Edit here to update properties, testimonials, FAQs and activities.

export const SITE = {
  name: "Cheshire Holidays",
  legalName: "Dutton Locks Leisure Ltd",
  logo: "https://customer-assets.emergentagent.com/job_shepherd-huts-demo/artifacts/hm0mjugc_Screenshot_20260523_085046_WhatsApp%20%281%29.jpg",
  tagline: "The Perfect Place to Relax",
  phone: "07469 365589",
  phoneHref: "tel:+447469365589",
  whatsapp: "447469365589",
  whatsappHref: "https://wa.me/447469365589?text=Hi%20Cheshire%20Holidays%2C%20I%27d%20like%20to%20enquire%20about%20a%20stay.",
  email: "cheshireholidays@gmail.com",
  emailHref: "mailto:cheshireholidays@gmail.com",
  address: "1 Dutton Locks, Northwich, CW8 3QQ",
  instagram: "https://instagram.com/cheshireholidays?igshid=xy2c9ccsx0cv",
  bookingExternal: "https://book.hostfully.com/cheshire-holidays",
  mapUrl:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2382.13!2d-2.6196!3d53.2862!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNTPCsDE3JzEwLjMiTiAywrAzNyc3LjAiVw!5e0!3m2!1sen!2suk!4v1700000000000",
};

export const HERO = {
  eyebrow: "Cheshire Countryside Holiday Retreats",
  title: ["The Perfect Place", "to Relax"],
  subtitle:
    "Hand-built shepherd's huts and beautifully restored Victorian cottages set along the River Weaver, private lakes and the edge of Delamere Forest.",
  // Hero rotates through these images. Listed in display order.
  images: [
    "https://a0.muscache.com/im/pictures/miso/Hosting-678041848319804927/original/deb656ad-9ce0-40d2-9835-d22a4bc07750.jpeg",
    "https://a0.muscache.com/im/pictures/6e5e135d-38e5-4db2-be4e-34d6a667f9f9.jpg",
    "https://a0.muscache.com/im/pictures/miso/Hosting-678041848319804927/original/47bcc1cc-c680-4a21-930f-aab6050a4c32.jpeg",
    "https://www.duttonlocks.co.uk/wp-content/uploads/2024/01/dutton2-1920w.png",
    "https://customer-assets.emergentagent.com/job_shepherd-huts-demo/artifacts/4cxndd9w_image.png",
  ],
};

export const PROPERTIES = [
  {
    id: "lock-keepers-cottage",
    name: "Lock Keeper's Cottage",
    type: "Victorian Cottage · Dutton Locks",
    sleeps: 4,
    bedrooms: 2,
    image:
      "https://customer-assets.emergentagent.com/job_shepherd-huts-demo/artifacts/afrbgubl_image.png",
    images: [
      "https://customer-assets.emergentagent.com/job_shepherd-huts-demo/artifacts/afrbgubl_image.png",
      "https://customer-assets.emergentagent.com/job_shepherd-huts-demo/artifacts/4i9udsz1_image.png",
      "https://customer-assets.emergentagent.com/job_shepherd-huts-demo/artifacts/4cxndd9w_image.png",
    ],
    galleryRoute: "/lock-keepers-gallery",
    description:
      "A two-bedroom Victorian holiday cottage on a private island in the River Weaver at Dutton Locks, Cheshire. Enjoy a private wood-fired hot tub overlooking the Weaver Valley with views of the magnificent Dutton Viaduct. Ideal for family stays, romantic getaways and slow countryside weekends, with canal walks, cycling and paddleboarding straight from the door.",
    highlights: [
      "Private island setting",
      "Wood-fired hot tub",
      "Views of Dutton Viaduct",
      "Sleeps up to 4 guests",
    ],
  },
  {
    id: "acton-bridge-cottage",
    name: "Acton Bridge Cottage",
    type: "Village Cottage · Acton Bridge",
    sleeps: 4,
    bedrooms: 2,
    image:
      "https://customer-assets-wrfwihn1.emergentagent.net/job_shepherd-huts-demo/artifacts/6cqrjk1p_AB%20house",
    galleryRoute: "/acton-bridge-gallery",
    description:
      "A charming two-bedroom Victorian holiday cottage in Acton Bridge village, Cheshire — fully refurbished in 2021. Steps from the village pub and Acton Bridge station (direct train to Liverpool), with a private meadow orchard of 14 fruit trees and countryside walks from the doorstep.",
    highlights: [
      "Refurbished in 2021",
      "Meadow orchard with 14 fruit trees",
      "Steps from the village pub",
      "Train link to Liverpool nearby",
    ],
  },
  {
    id: "oakmere-cottage",
    name: "2 Bedroom Cottage at Oakmere",
    type: "Lakeside Cottage · Oakmere",
    sleeps: 4,
    bedrooms: 2,
    image:
      "https://customer-assets.emergentagent.com/job_shepherd-huts-demo/artifacts/seee2gs1_image.png",
    images: [
      "https://customer-assets.emergentagent.com/job_shepherd-huts-demo/artifacts/seee2gs1_image.png",
      "https://customer-assets.emergentagent.com/job_shepherd-huts-demo/artifacts/bhl48ex5_image.png",
    ],
    galleryRoute: "/oakmere-cottage-gallery",
    description:
      "A beautifully refurbished 2-bedroom lakeside holiday cottage at Oakmere, Cheshire. Set in its own landscaped gardens overlooking the lake, with two outside terraces, a brand new kitchen with a large island, a cosy snug with wood-burning stove and a downstairs WC. Just 5 minutes from Delamere Forest and off the Whitegate Way — a great base for walks, cycling and family holidays.",
    highlights: [
      "Refurbished in 2022",
      "Lake views & two terraces",
      "Wood-burning stove in the snug",
      "5 mins from Delamere Forest",
    ],
  },
  {
    id: "shepherds-hut-dutton",
    name: "Shepherd's Hut at Dutton Locks",
    type: "Shepherd's Hut · River Island",
    sleeps: 2,
    bedrooms: 1,
    image:
      "https://customer-assets.emergentagent.com/job_shepherd-huts-demo/artifacts/jmwqrg26_image.png",
    images: [
      "https://customer-assets.emergentagent.com/job_shepherd-huts-demo/artifacts/jmwqrg26_image.png",
      "https://customer-assets.emergentagent.com/job_shepherd-huts-demo/artifacts/weotc55j_image.png",
    ],
    tourUrl: "https://vr-video-studio.emergent.host/property/dl-shepherds-hut",
    galleryRoute: "/dutton-locks-hut-gallery",
    description:
      "A hand-built shepherd's hut with wood-fired hot tub on a private island in the River Weaver at Dutton Locks, Cheshire. Fully refitted in 2026, set in landscaped gardens with birdsong and the sound of the river. Perfect for a romantic Cheshire shepherd's hut break for two.",
    highlights: [
      "Fully refitted in 2026",
      "Wood-fired hot tub",
      "Private island setting",
      "Sleeps 2 · romantic escape",
    ],
  },
  {
    id: "oakmere",
    name: "Oakmere",
    type: "Shepherd's Hut · Woodland Mere",
    sleeps: 2,
    bedrooms: 1,
    image:
      "https://customer-assets-wrfwihn1.emergentagent.net/job_shepherd-huts-demo/artifacts/n003h6jm_Oakmere%20hut.webp",
    tourUrl:
      "https://tourmkr.com/F1doGpOjh8/45803687p&43.36h&89.18t",
    galleryRoute: "/oakmere-gallery",
    description:
      "A woodland shepherd's hut with wood-fired hot tub overlooking a private Cheshire mere. Spot Canadian geese and herons from your elevated deck. Private bathroom, fire pit and hot tub. Minutes from Delamere Forest, Oulton Park and Tarporley — a peaceful romantic hot tub retreat.",
    highlights: [
      "Private mere views",
      "Elevated deck & fire pit",
      "Private bathroom",
      "Near Delamere Forest",
    ],
  },
  {
    id: "the-hide",
    name: "The Hide",
    type: "Lakeside Lodge · New for 2025",
    sleeps: 2,
    bedrooms: 1,
    image:
      "https://customer-assets-wrfwihn1.emergentagent.net/job_shepherd-huts-demo/artifacts/lqhvp2dj_Oakmere%20lodge.webp",
    images: [
      "https://customer-assets-wrfwihn1.emergentagent.net/job_shepherd-huts-demo/artifacts/lqhvp2dj_Oakmere%20lodge.webp",
      "https://customer-assets-wrfwihn1.emergentagent.net/job_shepherd-huts-demo/artifacts/vkljo0uj_Oakmere%20Hide%20photo.jpeg",
      "https://customer-assets-wrfwihn1.emergentagent.net/job_shepherd-huts-demo/artifacts/lvx9mqnp_oakmere%20hut%201.jpeg",
      "https://customer-assets-wrfwihn1.emergentagent.net/job_shepherd-huts-demo/artifacts/9drhll56_oakmere%20hut%202.jpeg",
    ],
    tourUrl:
      "https://tourmkr.com/F1TZZwwoBT/45808014p&51.06h&88.81t",
    galleryRoute: "/the-hide-gallery",
    description:
      "The Hide is our newest Cheshire retreat — a lakeside holiday lodge designed for total seclusion. Floor-to-ceiling glass framing the water at your doorstep, dark skies for stargazing at night. A luxury Cheshire lodge for two.",
    highlights: [
      "Lakeside setting",
      "New build for 2025",
      "Floor-to-ceiling glass",
      "Total seclusion",
    ],
    badge: "New for 2025",
  },
];

export const EXPERIENCES = [
  {
    title: "Wood-fired Hot Tubs",
    body:
      "Each of our shepherd's huts and lodges has its own wood-fired hot tub. The cottage at Dutton Locks also has a wood-fired hot tub looking across the Weaver Valley. Steam rising, stars above.",
    image:
      "https://customer-assets.emergentagent.com/job_shepherd-huts-demo/artifacts/ggb5c0s0_image.png",
  },
  {
    title: "Walking & Cycling",
    body:
      "Step from the door onto the Weaver towpath, the Delamere Way or the Whitegate Way. Bike hire available locally.",
    image:
      "https://customer-assets.emergentagent.com/job_shepherd-huts-demo/artifacts/c45dt3by_image.png",
  },
  {
    title: "Paddleboarding & Kayaking",
    body:
      "The River Weaver is gentle, wide and beautiful — perfect for a paddleboard or kayak straight from the bank.",
    image:
      "https://customer-assets.emergentagent.com/job_shepherd-huts-demo/artifacts/tssmole9_AdobeExpressPhotos_b566b7a3d5fb4b83a2e74afbb1d6e7ee_CopyEdited.jpg",
  },
  {
    title: "Country Pubs",
    body:
      "The Leigh Arms, the Hazel Pear, the Fishpool Inn — welcoming pubs and excellent food, all a short stroll or drive away.",
    image:
      "https://customer-assets.emergentagent.com/job_shepherd-huts-demo/artifacts/adfiy2ut_image.png",
  },
];

export const NEARBY = [
  { label: "Delamere Forest", url: "https://www.forestryengland.uk/delamere-forest" },
  { label: "Go Ape at Delamere", url: "https://goape.co.uk/locations/delamere" },
  { label: "Anderton Boat Lift", url: "https://canalrivertrust.org.uk/things-to-do/museums-and-attractions/anderton-boat-lift-and-visitor-centre-cheshire" },
  { label: "Arley Hall (Peaky Blinders filming location)", url: "https://www.arleyhallandgardens.com/" },
  { label: "Black Prince boat hire — Bartington", url: "https://www.black-prince.com/hire-bases/acton-bridge-hire-base/" },
  { label: "Vale Royal Falconry Centre", url: "https://www.valeroyalfalconry.com/" },
  { label: "Blue Planet Aquarium — Cheshire Oaks", url: "https://www.blueplanetaquarium.com/" },
  { label: "The Danny — gin & sightseeing cruises", url: "https://www.thedanny.co.uk/" },
  { label: "Manley Mere", url: "https://www.manleymere.co.uk/" },
  { label: "The Crocky Trail", url: "https://crockytrail.co.uk/" },
  { label: "The Leigh Arms pub", url: "https://www.leigharms.co.uk/" },
  { label: "The Hazel Pear, Acton Bridge", url: "https://thehazelpearactonbridge.pub/" },
  { label: "The Fishpool Inn", url: "https://thefishpoolinn.co.uk/" },
  { label: "Dutton Locks Canal Circular walk", url: "https://www.komoot.com/tour/274352813?ref=atd" },
  { label: "Cliff Road · Pickerings Lock walk", url: "https://www.komoot.com/tour/274359036?ref=atd" },
];

export const OAKMERE_COTTAGE_GALLERY = [
  "https://a0.muscache.com/im/pictures/miso/Hosting-678041848319804927/original/deb656ad-9ce0-40d2-9835-d22a4bc07750.jpeg",
  "https://a0.muscache.com/im/pictures/miso/Hosting-678041848319804927/original/47bcc1cc-c680-4a21-930f-aab6050a4c32.jpeg",
  "https://a0.muscache.com/im/pictures/miso/Hosting-678041848319804927/original/2b3b402b-abf5-4030-aa6c-b2753a93f687.jpeg",
  "https://a0.muscache.com/im/pictures/miso/Hosting-678041848319804927/original/4515bfdc-8ff9-4fc4-a1a3-10293bbcf5d2.jpeg",
  "https://a0.muscache.com/im/pictures/miso/Hosting-678041848319804927/original/7092838b-ce70-435d-9b14-a2ac9eeba222.jpeg",
  "https://a0.muscache.com/im/pictures/miso/Hosting-678041848319804927/original/c65fa185-716e-47c1-9a2a-7a4866b732b5.jpeg",
  "https://a0.muscache.com/im/pictures/miso/Hosting-678041848319804927/original/d542998f-4003-42b1-9ba3-bc4050188650.jpeg",
  "https://a0.muscache.com/im/pictures/1c2f549a-f2b1-4437-a44f-2416e84993be.jpg",
  "https://a0.muscache.com/im/pictures/2ae3e9c7-52e8-46c3-bdf6-dddba130cec4.jpg",
  "https://a0.muscache.com/im/pictures/34b28d6e-49ec-4323-9db2-cd4e4522bf49.jpg",
  "https://a0.muscache.com/im/pictures/5e41705b-76ab-4473-9577-a3009e9da76b.jpg",
  "https://a0.muscache.com/im/pictures/6023af68-7267-40b5-bcd9-99d4d5a16ac5.jpg",
  "https://a0.muscache.com/im/pictures/6e5e135d-38e5-4db2-be4e-34d6a667f9f9.jpg",
  "https://a0.muscache.com/im/pictures/79104f9a-4573-433e-bdfc-ca929664031a.jpg",
  "https://a0.muscache.com/im/pictures/84ded481-a0f0-4305-8653-973fa6f443d0.jpg",
  "https://a0.muscache.com/im/pictures/8da363a2-2124-416d-a732-859a52f042dd.jpg",
  "https://a0.muscache.com/im/pictures/9d863d21-00d7-424c-99e7-7f2a69e929ec.jpg",
  "https://a0.muscache.com/im/pictures/cf4a7cf4-7007-47b6-bded-c4962ac01d96.jpg",
  "https://a0.muscache.com/im/pictures/e1ccb40b-6e59-43de-ab4c-8d69f479dd70.jpg",
];

export const LOCK_KEEPERS_GALLERY = [
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/11bc20ce-0064-4366-a3ce-542e57e9c6f2",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/06b126a1-51e9-4358-8147-66231add1d46",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/76c0f346-22bf-4c38-aeff-4771891ca482",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/ee255dd6-9b77-42bb-96ed-32c9c44701df",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/93a96603-f410-4cd9-a9ca-6221d3b1ecd6",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/65dc2482-fe32-4d58-bd80-17deb7138423",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/794f4099-44b8-4382-a87c-dd2933633559",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/612e7c41-f55f-40ad-bd9b-41022c6b167e",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/9e83afe2-1099-42bd-9f7e-3382c6fde9fa",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/18a72cc7-d85d-4ff7-92ab-6a6f51801c7e",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/37cee78b-f951-43f3-beb6-3e71381172ec",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/d9d66bd3-090b-4a8c-9316-f36bae1ccb33",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/f81b997d-28f8-4981-9d79-aff5beaa6fee",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/cfb943b5-48b4-4806-af60-c45d39fccde2",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/0e2f16bb-4ec4-41bf-87b9-364566f7f461",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/9fce80ea-f6a6-4f0e-be7b-b43a1ed9d89c",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/5c1bb87e-8f70-40aa-b18f-8f657297e54b",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/5a05d459-0fb5-4076-a6e6-809b5d3835c1",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/1e1e9557-d85a-4694-bf60-d7b3d1b332fd",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/91588e29-d56e-4771-b9b8-bd439f7b5a77",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/5e64dcb3-a285-45ff-8bb8-066e6fa34bf5",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/4e343215-d647-4606-a328-8a1ce894e281",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/e1be37ee-db5b-4aaa-8ba2-a98975b8e9ec",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/3c6f7822-07d3-4d49-8ac2-5a905cdf718d",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/71df6b71-a86a-45a9-97cf-0fb70257f7ad",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/1608a93c-a42c-4fc2-a0e8-e4a26f6741d5",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/bc41835f-068c-4a2f-aefb-24b5c2a61894",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/db29dd25-29ef-49a5-a970-14f78bba0785",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/f2dad006-3388-48e4-9fe2-4ce43868180f",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/cac13e69-58ef-4b4a-a81c-193538267302",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/94a82217-184e-45e3-b78a-7a1ab5490aa2",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/8f97baa8-0321-4ab3-9dbf-c1afb3811283",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/9bd92321-d0c6-4b01-b06b-f011f943edd4",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/a8a0bb87-6c80-4e3b-97fb-62ee24879d9b",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/10eec785-4810-421b-b25b-25e0f5d8bdbb",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/c78a934c-c9d1-42d4-a344-25e92b237184",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/87b91b52-79e4-4517-9fd6-0730ad9927b1",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/ebfefb93-1e1f-4cf6-baa4-4d4a51ca8a15",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/78d96f2c-0e54-464e-b038-06f3fe23bcf7",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/56d1afe5-bd36-4f12-a1c4-04a2d7582ef9",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/0e294968-3bec-489c-a6ef-71b2d55ab262",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/60cc6c54-fd78-4499-af6c-0951b724a374",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/1a335f2d-5df1-45ab-813d-4a790b935bb9",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/458f2372-c4d1-49aa-80b0-d8e7e61bb43e",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/612dbbd6-ed7c-4e8f-8efe-7ee5eb242d22",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/b2d330a6-55b9-4a4c-bdc6-bae6bfb76dbb",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/c300381e-9764-4a19-8d9a-c2b899b88077",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/1edad347-b7d5-4c64-9a92-3ce8f1d39e70",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/37b4a7d9-897e-49aa-b1e4-7e5331066939",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/5b43c067-8923-41b0-9691-6d7fdd0c720c",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/610c67e5-6936-4411-832e-1d11c84e40d0",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/f7cd80f0-5a88-4c9b-b2ca-ab220aae3e5f",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/2f8902e3-d929-4fe3-9d4f-1c58ebbf35bb",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/da0e9791-f264-44bf-8810-dc0bec9edc19",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/eaa0d908-674a-4d26-9525-0fcd47ec61a2",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/3282b792-118e-483b-8eee-e2fb347a4d19",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/ca971bad-32b2-415a-8646-5e992cf1c8e0",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/6ce845f2-b3cd-4620-b503-033233369a66",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/f8b51baf-c10a-4a86-ae59-4700cc439caf",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/b5b93c40-9ced-40b3-9c9f-3f330fe584fe",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/fd38960d-97f1-4b8e-8c3e-5d46e256e623",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/23575387-4565-4ac3-aa37-07d96ec22915",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/51fcaf48-9799-435c-9d88-f82e27ee7c89",
];

export const ACTON_BRIDGE_GALLERY = [
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/4bb1ae46-73d6-47d3-a3ad-95674e84c61b",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/246a86c8-df64-4f85-b145-5f02c5401e04",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/fab3a2dc-c719-426b-80d5-9f2072a794aa",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/3e8c5ce8-8082-47e5-92c0-03ad3f83b6c6",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/16043411-40a6-4e0f-bbe0-ffec94d73c3d",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/cd3021a4-2b8b-4ef5-9ec6-070da7518f19",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/0153fadb-2b8b-4af1-b3f4-ff065fd6f7db",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/a340d549-f48c-42e3-8549-94ffce7e7d96",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/af6a5e42-324a-404a-9e0e-14ad49ff5205",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/224df89c-f235-4de4-b01f-09504468f79d",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/d4132b3e-8a23-4bc1-b831-2bdbb6991554",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/82d3270a-2d3d-4954-bf47-230157b4526a",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/abeb90a8-26dc-432c-9d7d-c048457dabaf",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/c67addb6-53f9-478d-8d7b-3c56bc456829",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/0115d4d3-a3af-4a40-99f7-21f95311683a",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/a68b9533-d2ee-487a-a17b-32f516b106eb",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/345275e8-7016-432c-9760-c4693e09cd8a",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/0ed39f01-31d9-438d-be82-5ff56e5c2fba",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/fb2e72cf-fe4b-4f09-9f70-cb0de4edfa5f",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/1770a99a-d995-43ca-befa-673acc653183",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/b53b45e9-71be-499a-b0e7-bdaec5caf3f7",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/f5f0dd5d-9c41-4d6a-aae3-8ee916d055cc",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/a730b957-2a18-4343-82b8-28d7efe47e94",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/4a61f9c1-c995-4718-ae77-9ecd12edbf03",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/69b975a0-71ef-4471-a505-4704ffdb59fa",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/fb2d152b-af52-4359-bf41-409e959fa067",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/49aa21c6-85ba-4114-addc-5ce563b84b18",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/51c17bcd-7ba9-442c-ac91-6bbc1d16c622",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/ab38a32c-745b-4f2f-9ca7-c7b6d4fe2b9c",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/90a7f965-45e5-4946-81fe-88d32d752e27",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/bb19228f-f610-4b92-baa4-33ba68344e55",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/b152f96c-7b75-4842-9096-0b1c38b871ee",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/18eafe91-aba8-4c40-b21e-b2b30c0ddbca",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/4043a2d7-a753-4ca8-a42f-67e245f7c495",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/ccf1f52f-b685-45b8-b3eb-eff1c852adfd",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/9eedb5e7-53e3-4fbf-9cef-f9c7c1822fcc",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/f8e29ee6-6bad-47d9-93e4-1d8484c91322",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/cb2f450d-5d3e-4e12-acda-7c47950d698c",
];

export const DUTTON_HUT_GALLERY = [
  { src: "https://customer-assets.emergentagent.com/job_shepherd-huts-demo/artifacts/1cgqvsls_20260626_145044%20%281%29.webp", rotate: 90 },
  "https://customer-assets.emergentagent.com/job_shepherd-huts-demo/artifacts/ovn088k5_20260625_122610.webp",
  "https://customer-assets.emergentagent.com/job_shepherd-huts-demo/artifacts/znl8q45g_20260621_143447.webp",
  "https://customer-assets.emergentagent.com/job_shepherd-huts-demo/artifacts/4hv5qsex_20260626_145138~2.webp",
  "https://customer-assets.emergentagent.com/job_shepherd-huts-demo/artifacts/hhsmqzy3_Screenshot_20260625_144415.webp",
  "https://customer-assets.emergentagent.com/job_shepherd-huts-demo/artifacts/38qk5g0y_20260702_132814.webp",
  { src: "https://customer-assets.emergentagent.com/job_shepherd-huts-demo/artifacts/hzmi802a_20260626_145057.webp", rotate: 90 },
  "https://customer-assets.emergentagent.com/job_shepherd-huts-demo/artifacts/kurdw1lq_Screenshot_20260617_160304_Photos.webp",
  "https://customer-assets.emergentagent.com/job_shepherd-huts-demo/artifacts/5ztj3goi_20260702_132814.webp",
  "https://customer-assets.emergentagent.com/job_shepherd-huts-demo/artifacts/3h2dtslx_Screenshot_20260625_144415.webp",
  "https://placehold.co/1200x900/1B3B36/FAF9F6?text=Photo+12+Coming+Soon",
];


export const HIDE_GALLERY = [
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1487565018016642435/original/36575d04-d8c3-47f1-8913-43a593d70f11.jpeg",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1487565018016642435/original/3b8bdfe2-0816-4e64-b5d4-5b29918fe372.jpeg",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1487565018016642435/original/4820ffe9-35a5-4cee-956c-7484c3c4cd89.jpeg",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1487565018016642435/original/4e477f56-b3d9-4d49-bd34-2f4fea92d7f7.jpeg",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1487565018016642435/original/4e5edf31-0f92-404c-835f-b4f835a08c7b.jpeg",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1487565018016642435/original/65066303-a571-4a55-9753-6a82bf51eac1.jpeg",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1487565018016642435/original/72ace568-ea41-4152-ae6d-522888508f48.jpeg",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1487565018016642435/original/8c598a61-53df-4e91-b401-0e92826d1c49.jpeg",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1487565018016642435/original/8ce0f08e-f99d-4c56-a229-507cc6437014.jpeg",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1487565018016642435/original/8fc75f66-f6b6-4d17-a21c-35a3b48c1735.jpeg",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1487565018016642435/original/a5914547-e72d-4c39-9a59-e4ce4bddd218.jpeg",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1487565018016642435/original/aa39823d-dad2-442c-bf87-16bb25f6b931.jpeg",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1487565018016642435/original/c5127f6e-7cde-4663-91d6-07a3e4e5781b.jpeg",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1487565018016642435/original/f0e3cbe7-fecb-444e-8042-f2855fe33486.jpeg",
];


export const OAKMERE_GALLERY = [
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/0020470b-d00e-479b-8c5a-775348bc729a",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/6d48bc50-4e30-4f4c-9575-4d8ebd7ba37f",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/466cac20-367b-433e-aa10-2828e30eb78a",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/fc792366-5fac-4597-9e4f-2719ed945a11",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/10ecde8d-04b0-45a4-9290-1a816bdb9615",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/e333712f-116d-4fb7-b0c2-aa348de9c1cd",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/461b80ef-e2b1-42cc-9303-e4327a6eea76",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/83d28878-2f43-40b9-895c-de182336a832",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/fab22bfd-9103-4417-8b3a-d149a7a9b7f6",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/6eabea52-a098-4536-baef-0ad3e7d4b911",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/39eda02d-e756-4bb7-9f04-48b248f22743",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/4f6665e2-d0fd-4b37-80ce-573b6497335d",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/42db1d38-88ff-4787-8a12-fa8f6fa06d81",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/65c2e590-c129-455a-8517-26ef5b3fc689",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/3e88affb-425d-4198-bb0b-57b1a24251d6",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/62f61693-521e-4eb0-bba0-9df206a1b73f",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/6fdb0e7b-09f7-4f28-8dbf-0c6a5da33c1e",
  "https://iac-prod-orbirental-images-bucket.s3.amazonaws.com/13ce159e-260c-49ff-8a7e-d44dbc760f00",
];



export const TESTIMONIALS = [
  {
    quote:
      "Absolutely amazing! The drive to the location was beautiful, easy to find. Tea, coffee, little extras. The bath is amazing. The hot tub was great too — such a picturesque garden. Three nights was not enough.",
    name: "Rachel",
    detail: "April 2022 · Dutton Locks Cottage",
  },
  {
    quote:
      "Beautiful location for a little slice of heaven away from the stresses of life. Sitting in the hot tub with such a stunning view truly allows you to escape.",
    name: "Sarah",
    detail: "May 2022 · Dutton Locks Cottage",
  },
  {
    quote:
      "We had a lovely Christmas in the cottage. Pictures and description all true to actual. Great location, local pub food delicious. Would definitely recommend.",
    name: "Tracy",
    detail: "December 2021 · Acton Bridge Cottage",
  },
  {
    quote:
      "Our second visit to this property — excellent location, excellent accommodation. You couldn't ask for more for a relaxing weekend.",
    name: "John",
    detail: "May 2022 · Dutton Locks Shepherd's Hut",
  },
];

export const FAQS = [
  {
    q: "How do I light the wood-fired hot tub?",
    a: "We send detailed instructions before arrival and there is a printed guide in your cottage or hut. It usually takes 2–3 hours to reach temperature — we also offer a pre-heat service for a small charge.",
  },
  {
    q: "Can I extend my stay?",
    a: "Yes — please get in touch and we will check availability for additional nights.",
  },
  {
    q: "Can I hire a bathrobe for the hot tub?",
    a: "We have a small collection of Christy bathrobes available for hire. We also recommend bringing flip flops for getting in and out of the hot tub.",
  },
  {
    q: "Can the hot tub be pre-heated for our arrival?",
    a: "Yes — please request this when booking. A small charge applies for the pre-heat service.",
  },
  {
    q: "How do I book again or recommend friends?",
    a: "Contact us directly through the enquiry form or by phone, or book via Airbnb.",
  },
  {
    q: "What is there to do in the area?",
    a: "Plenty — walking, cycling, paddleboarding, country pubs, Delamere Forest, Arley Hall, the Anderton Boat Lift and more. See our Things To Do section.",
  },
  {
    q: "Where are the nearest shops?",
    a: "The nearest shop is at the petrol station, with a wider choice in Weaverham. We can also arrange pre-ordered drinks for your arrival.",
  },
  {
    q: "How do I get more firewood or kindling?",
    a: "We keep an honesty box on site stocked with additional logs and kindling — just let us know and we'll arrange more.",
  },
];
